import { useQuery } from "react-query";
import { fetchZipCodeHouses } from "./api";

export function useHouses(filters, options = {}) {
  return useQuery(
    ["fetchZipCodeHouses", filters],
    () => fetchZipCodeHouses(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
